import React, { useState } from "react";

import { Icon } from "../../../components/Icon/Icon";

import cs from "classnames";

import { useNavigate } from "react-router-dom";
import { useInView } from "react-intersection-observer";

import hover353Image from "../../../assets/images/Infinite353/353-hover.png";
import hover50x60Image from "../../../assets/images/Infinite60x50/60x50-hover.png";
import hover110x313Image from "../../../assets/images/Infinite313x110/313x110-hover.png";

import "./ProductsGroup.scss";

const ProductsGroup = () => {
  const [hover353, setHover353] = useState(false);
  const [hover60, setHover60] = useState(false);
  const [hover50, setHover50] = useState(false);
  const [hover313, setHover313] = useState(false);
  const [hover110, setHover110] = useState(false);
  const navigate = useNavigate();
  const { ref: fiveGDevicesRef, inView: fiveGDevicesVisibility } = useInView();
  const { ref: wifiSixDevicesRef, inView: wifiSixDevicesVisibility } =
    useInView();
  const { ref: product353Ref, inView: product353Visibility } = useInView();
  const { ref: product60Ref, inView: product60Visibility } = useInView();
  const { ref: product50Ref, inView: product50Visibility } = useInView();
  const { ref: product313Ref, inView: product313Visibility } = useInView();
  const { ref: product110Ref, inView: product110Visibility } = useInView();

  return (
    <div className="ProductsGroup">
      <div className="ProductsGroup__5g">
        <div
          ref={fiveGDevicesRef}
          className={cs(
            "ProductsGroup__5g-title",
            fiveGDevicesVisibility && "ProductsGroup__5g-title-animation",
          )}
        >
          5G FWA
        </div>
        <div className="ProductsGroup__5g-devices">
          <div
            ref={product353Ref}
            onMouseEnter={() => {
              setHover353(true);
            }}
            onMouseLeave={() => {
              setHover353(false);
            }}
            onClick={() => {
              navigate("/infinite-353");
            }}
            className={cs(
              "ProductsGroup__product",
              product353Visibility && "ProductsGroup__product-animation353",
              "ProductsGroup__product-353",
            )}
          >
            <div className="ProductsGroup__brand">Infinite</div>
            <div
              className={cs(
                "ProductsGroup__container",
                "ProductsGroup__container-353",
              )}
            >
              <div className={cs("ProductsGroup__id", "ProductsGroup__id-353")}>
                353
              </div>
              <div className="ProductsGroup__image-group">
                <Icon
                  className={cs(
                    "ProductsGroup__image",
                    !hover353 && "ProductsGroup__image-active",
                    "ProductsGroup__image-353",
                  )}
                  icon="353"
                />
                <img
                  src={hover353Image}
                  className={cs(
                    "ProductsGroup__render",
                    hover353 && "ProductsGroup__render-active",
                    "ProductsGroup__render-353",
                  )}
                />
              </div>
            </div>
            <div className="ProductsGroup__description">
              Revolutionary Powerhouse
            </div>
          </div>
          <div className="ProductsGroup__product-group">
            <div
              ref={product60Ref}
              className={cs(
                "ProductsGroup__product",
                product60Visibility && "ProductsGroup__product-animation60",
              )}
              onMouseEnter={() => {
                setHover60(true);
              }}
              onMouseLeave={() => {
                setHover60(false);
              }}
              onClick={() => {
                navigate("/infinite-60");
              }}
            >
              <div className="ProductsGroup__brand">Infinite</div>
              <div
                className={cs(
                  "ProductsGroup__container",
                  "ProductsGroup__container-60",
                )}
              >
                <div className="ProductsGroup__id">60</div>
                <div className="ProductsGroup__image-group">
                  <Icon
                    className={cs(
                      "ProductsGroup__image",
                      !hover60 && "ProductsGroup__image-active",
                    )}
                    icon="50-60"
                  />
                  <img
                    src={hover50x60Image}
                    className={cs(
                      "ProductsGroup__render",
                      hover60 && "ProductsGroup__render-active",
                    )}
                  />
                </div>
              </div>
              <div className="ProductsGroup__description">
                Acceleration Redefined
              </div>
            </div>
            <div
              ref={product50Ref}
              className={cs(
                "ProductsGroup__product",
                product50Visibility && "ProductsGroup__product-animation50",
              )}
              onMouseEnter={() => {
                setHover50(true);
              }}
              onMouseLeave={() => {
                setHover50(false);
              }}
              onClick={() => {
                navigate("/infinite-50");
              }}
            >
              <div className="ProductsGroup__brand">Infinite</div>
              <div
                className={cs(
                  "ProductsGroup__container",
                  "ProductsGroup__container-50",
                )}
              >
                <div className="ProductsGroup__id">50</div>
                <div className="ProductsGroup__image-group">
                  <Icon
                    className={cs(
                      "ProductsGroup__image",
                      !hover50 && "ProductsGroup__image-active",
                    )}
                    icon="50-60"
                  />
                  <img
                    src={hover50x60Image}
                    className={cs(
                      "ProductsGroup__render",
                      hover50 && "ProductsGroup__render-active",
                    )}
                  />
                </div>
              </div>
              <div className="ProductsGroup__description">
                Seamless Connection
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="ProductsGroup__wifi">
        <div
          ref={wifiSixDevicesRef}
          className={cs(
            "ProductsGroup__wifi-title",
            wifiSixDevicesVisibility && "ProductsGroup__wifi-title-animation",
          )}
        >
          Wi-Fi 6 Access Points
        </div>
        <div className="ProductsGroup__wifi-devices">
          <div
            ref={product313Ref}
            className={cs(
              "ProductsGroup__product",
              product313Visibility && "ProductsGroup__product-animation313",
            )}
            onMouseEnter={() => {
              setHover313(true);
            }}
            onMouseLeave={() => {
              setHover313(false);
            }}
            onClick={() => {
              navigate("/infinite-313");
            }}
          >
            <div className="ProductsGroup__brand">Infinite</div>
            <div
              className={cs(
                "ProductsGroup__container",
                "ProductsGroup__container-313",
              )}
            >
              <div className="ProductsGroup__id">313</div>
              <div className="ProductsGroup__image-group">
                <Icon
                  className={cs(
                    "ProductsGroup__image",
                    !hover313 && "ProductsGroup__image-active",
                  )}
                  icon="313-110"
                />
                <img
                  src={hover110x313Image}
                  className={cs(
                    "ProductsGroup__render",
                    hover313 && "ProductsGroup__render-active",
                  )}
                />
              </div>
            </div>
            <div className="ProductsGroup__description">
              The Rhythm of Next-Era
            </div>
          </div>
          <div
            ref={product110Ref}
            className={cs(
              "ProductsGroup__product",
              product110Visibility && "ProductsGroup__product-animation110",
            )}
            onMouseEnter={() => {
              setHover110(true);
            }}
            onMouseLeave={() => {
              setHover110(false);
            }}
            onClick={() => {
              navigate("/infinite-110");
            }}
          >
            <div className="ProductsGroup__brand">Infinite</div>
            <div
              className={cs(
                "ProductsGroup__container",
                "ProductsGroup__container-110",
              )}
            >
              <div className="ProductsGroup__id">110</div>
              <div className="ProductsGroup__image-group">
                <Icon
                  className={cs(
                    "ProductsGroup__image",
                    !hover110 && "ProductsGroup__image-active",
                  )}
                  icon="313-110"
                />
                <img
                  src={hover110x313Image}
                  className={cs(
                    "ProductsGroup__render",
                    hover110 && "ProductsGroup__render-active",
                  )}
                />
              </div>
            </div>
            <div className="ProductsGroup__description">Infinite Reach</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductsGroup;
